<template>
    <modal name="preview-modal" class="preview-modal"
           width="500" height="auto">
        <button class="close" @click="$modal.hide('preview-modal')">❌</button>

<!--        <div v-if="is_generated">-->
        <div class="m-header">
            <div class="h4">Auto-generated Preview</div>
            Allow customers to preview your video before purchase
        </div>
        <div class="m-body">
            <div class="row m-b-20">
                <div class="col-md-6">
                    <label class="text-secondary">
                        Start Time(s)
                        <input class="form-control" min="0" placeholder="00:00:01" type="number" v-model="generated_start_time"/>
                    </label>
                </div>
                <div class="col-md-6">
                    <label class="text-secondary">
                        Length(s)
                        <input class="form-control" min="0" placeholder="00:03:00" type="number" v-model="generated_duration"/>
                    </label>
                </div>
            </div>
            <div class="row m-b-10">
                <div class="col-md-6">
<!--                        <button @click="is_generated = false" class="big-btn inverse" type="button">SWITCH TO TRAILER</button>-->
                    <button @click="$modal.hide('preview-modal')" class="big-btn inverse" type="button">CANCEL</button>
                </div>
                <div class="col-md-6">
                    <button @click="generatePreview()" class="big-btn" type="button">CONTINUE</button>
                </div>
            </div>
        </div>

<!--        <div v-else>-->
<!--            <div class="m-header">-->
<!--                By switching to-->
<!--                <b>TRAILER</b>-->
<!--                you will not be able to set an auto-generated preview anymore.-->
<!--            </div>-->
<!--            <div class="m-body">-->
<!--                <div class="m-b-20 center textcenter">-->
<!--                    Do you want to continue?-->
<!--                </div>-->
<!--                <div class="row m-b-10">-->
<!--                    <div class="col-md-6">-->
<!--                        <button @click="is_generated = true" class="big-btn inverse" type="button">CANCEL</button>-->
<!--                    </div>-->
<!--                    <div class="col-md-6">-->
<!--                        <button @click="setPreview('trailer')" class="big-btn" type="button">CONTINUE</button>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->
<!--        </div>-->
    </modal>
</template>
<script>
    import {mapDynamicFields} from "./helpers/mapDynamicFields";

    export default {
        name: 'Modal_Preview',
        data () {
            return {
                spath: `Videos.uploads`,
                is_generated: true,
            }
        },
        computed: {
            ...mapDynamicFields('spath', {
                generated_status: 'generated.api_state.status',
                generated_start_time: 'generated.api_state.start_time',
                generated_duration: 'generated.api_state.duration',
            }),
            preview_type: {
                get(){
                    return this.$store.getters['Videos/preview_type']('main')
                },
                set(value){
                    this.$store.commit('Videos/updateField', {
                        path: 'uploads.main.ui_state.preview_type', value: value
                    })
                }
            },
            is_main_video_uploaded: function () { return !!this.main_video_origin_s3_path },
        },
        methods: {
            generatePreview(){
                this.preview_type = 'generated';
                this.$root.$emit('generate_preview');
                this.$modal.hide('preview-modal')
            },
        }
    }
</script>

<style lang="scss" scoped>
    .preview-modal {
        .close {
            font-weight: 300;
            font-size: 2rem;
            padding: 3px 5px;
            &:focus {
                outline: none;
            }
        }
        .m-header {
            padding: 1rem;
            border-bottom: 1px solid #e9ecef;
            text-align: center;
        }
        .m-body {
            padding: 1rem;
        }

        input.form-control {
            border-bottom: 1px solid #d1d3d4;
            margin-top: 0;
            padding: 0;
            height: 30px;
        }
        .disabled, .radio-custom[disabled] + .radio-custom-label {
            opacity: 0.6;
            cursor: not-allowed;
            pointer-events: auto;
            &.btn-sm:hover {
                border: 1px solid #d1d3d4;
                background-color: #f8f8f9;
                color: #a7a9ac;
            }
        }
    }
</style>